import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee Assessment")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "row mt-4" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Name", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Term", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "col-md-2 mt-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "card mb-5 mb-xl-10" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#assessment_info",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Assessment Information")
  ])
], -1)
const _hoisted_32 = {
  id: "assessment_info",
  class: "collapse show"
}
const _hoisted_33 = { class: "collapse show" }
const _hoisted_34 = { class: "card-body border-top p-9" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  class: "current",
  "data-kt-stepper-element": "content"
}, null, -1)
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Assessment Title", -1)
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "col-md-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Total Training Days", -1)
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "card mb-5 mb-xl-10" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#assessment_list",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Training Assessment")
  ])
], -1)
const _hoisted_45 = {
  id: "assessment_list",
  class: "collapse show"
}
const _hoisted_46 = { class: "collapse show" }
const _hoisted_47 = { class: "card-body border-top p-9" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  class: "current",
  "data-kt-stepper-element": "content"
}, null, -1)
const _hoisted_49 = { class: "table-responsive mt-5" }
const _hoisted_50 = { class: "table table-borderless gy-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Action"),
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Photo"),
    /*#__PURE__*/_createElementVNode("th", null, "Reference No"),
    /*#__PURE__*/_createElementVNode("th", null, "Registration No"),
    /*#__PURE__*/_createElementVNode("th", null, "Trainee Name"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"160px"} }, "Assessment Date"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"160px"} }, "Assessor"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"160px"} }, "Competency"),
    /*#__PURE__*/_createElementVNode("th", null, "Assessment Status")
  ])
], -1)
const _hoisted_52 = { style: {} }
const _hoisted_53 = { class: "align-middle" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "text-light" }, "Confirm", -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "text-light" }, "Update", -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "align-middle" }
const _hoisted_61 = ["src"]
const _hoisted_62 = { class: "align-middle" }
const _hoisted_63 = { class: "align-middle" }
const _hoisted_64 = { class: "align-middle" }
const _hoisted_65 = { class: "align-middle" }
const _hoisted_66 = { class: "align-middle" }
const _hoisted_67 = { class: "align-middle" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle fs-3 text-danger" }, null, -1)
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { class: "align-middle" }
const _hoisted_73 = {
  key: 0,
  class: "text-success"
}
const _hoisted_74 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_75 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_76 = {
  key: 3,
  class: "text-danger"
}
const _hoisted_77 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_78 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_79 = {
  key: 0,
  class: "text-success"
}
const _hoisted_80 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_81 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_82 = {
  key: 3,
  class: "text-danger"
}
const _hoisted_83 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_84 = {
  key: 1,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Tranche",
                    modelValue: _ctx.trainee.tranche_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.tranche_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: trans.id,
                          label: trans.label,
                          value: trans.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(trans.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Partner",
                    modelValue: _ctx.trainee.entity_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trainee.entity_id) = $event)),
                    filterable: "",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trainingInstitute())),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associations, (assoc) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: assoc.id,
                          label: assoc.entity_short_name,
                          value: assoc.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("[" + _toDisplayString(assoc.entity_short_name) + "]-" + _toDisplayString(assoc.entity_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Institute",
                    modelValue: _ctx.trainee.training_institute_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.trainee.training_institute_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getCourseList()))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: inst.id,
                          label: inst.institute_name,
                          value: inst.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(inst.institute_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _hoisted_20,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    "collapse-tags": "",
                    placeholder: "Select Course",
                    modelValue: _ctx.trainee.course_info_id,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.trainee.course_info_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getBatchList()))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: course.id,
                          label: course.course_name,
                          value: course.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(course.course_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _hoisted_23,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    "collapse-tags": "",
                    placeholder: "Select Batch",
                    modelValue: _ctx.trainee.batch_info_id,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.trainee.batch_info_id) = $event)),
                    filterable: "",
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getAssessmentEligibleTerm())),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batches, (batch) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: batch.id,
                          label: batch.batch_sequence_number,
                          value: batch.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(batch.batch_sequence_number), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                (_ctx.termList.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _hoisted_26,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Term",
                        modelValue: _ctx.trainee.term_no,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.trainee.term_no) = $event)),
                        name: "batch_id",
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.termList, (info) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: info.term_no,
                              label: info.term_no,
                              value: info.term_no
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(info.term_no), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.checkAssessmentEligiblity())),
                    type: "button",
                    class: "btn btn-success mt-6 p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_28
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showAssessmentList == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        readonly: "",
                        value: _ctx.textAssessment
                      }, null, 8, _hoisted_39)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        readonly: "",
                        value: _ctx.courseInfo?.day
                      }, null, 8, _hoisted_42)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showAssessmentList == true)
      ? (_openBlock(), _createElementBlock("div", { key: _ctx.assessmentkey }, [
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("table", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("tbody", _hoisted_52, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.traineeList, (data, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51)"}
                          }, [
                            _createElementVNode("td", _hoisted_53, [
                              ((data.attendance_percentage >= data?.batch_info?.dropout_below_perc && data.training_assessment == null && this.trainee.term_no == '' && this.isTermAssessment == 0) || (data.attendance_percentage >= data?.batch_info?.dropout_below_perc && data.training_term_assessment == null && this.trainee.term_no != '' && this.isTermAssessment == 1))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.Approve(index, data.id)),
                                    title: "Confirm",
                                    class: "btn btn-bg-success btn-active-color-success btn-sm"
                                  }, _hoisted_56, 8, _hoisted_54))
                                : _createCommentVNode("", true),
                              ((data.attendance_percentage >= data?.batch_info?.dropout_below_perc && data?.training_assessment != null && data?.training_assessment?.is_certification == 0 && this.trainee.term_no == '' && this.isTermAssessment == 0) || (data.attendance_percentage >= data?.batch_info?.dropout_below_perc && data.training_term_assessment != null && data?.training_assessment?.is_certification == 0 && this.trainee.term_no != '' && this.isTermAssessment == 1))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.Approve(index, data.id)),
                                    title: "Update",
                                    class: "btn btn-bg-success btn-active-color-success btn-sm"
                                  }, _hoisted_59, 8, _hoisted_57))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_60, _toDisplayString(index + 1), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("img", {
                                src: 
                            _ctx.api_url + data?.attach_file_info?.file_path
                          ,
                                alt: "",
                                width: "32",
                                height: "32"
                              }, null, 8, _hoisted_61)
                            ]),
                            _createElementVNode("td", _hoisted_62, _toDisplayString(data?.reference_number), 1),
                            _createElementVNode("td", _hoisted_63, _toDisplayString(data?.registration_number), 1),
                            _createElementVNode("td", _hoisted_64, _toDisplayString(data?.trainee_name), 1),
                            _createElementVNode("td", _hoisted_65, [
                              _createVNode(_component_el_form_item, {
                                prop: "date",
                                class: "mb-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: _ctx.assessment[index].assessment_date,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.assessment[index].assessment_date) = $event),
                                    name: `assessment_date[${index}]`,
                                    "value-format": "YYYY-MM-DD",
                                    format: "DD-MM-YYYY",
                                    type: "date",
                                    style: {"width":"100%"}
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("td", _hoisted_66, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Assessor",
                                modelValue: _ctx.assessment[index].assessor_info_id,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.assessment[index].assessor_info_id) = $event),
                                name: `competency[${data.id}]`,
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assessors, (assessor) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: assessor.id,
                                      label: assessor?.employee_info?.name,
                                      value: assessor.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(assessor?.employee_info?.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                            ]),
                            _createElementVNode("td", _hoisted_67, [
                              (data.attendance_percentage < data?.batch_info?.dropout_below_perc)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_68, _hoisted_70))
                                : (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                    _createVNode(_component_el_select, {
                                      class: "form-select-solid",
                                      placeholder: "Select competency",
                                      modelValue: _ctx.assessment[index].competency,
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.assessment[index].competency) = $event),
                                      name: `competency[${data.id}]`,
                                      filterable: "",
                                      style: {"width":"100%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_option, {
                                          label: "Competent",
                                          value: "100"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Competent")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_option, {
                                          label: "Not Competent",
                                          value: "50"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Not Competent")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_option, {
                                          label: "Absent",
                                          value: "0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Absent")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                                  ]))
                            ]),
                            _createElementVNode("td", _hoisted_72, [
                              (this.trainee.term_no == '' && this.isTermAssessment == 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (data?.training_assessment?.assessment_score)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (data?.training_assessment?.assessment_score == 100)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_73, "Competent"))
                                            : (data?.training_assessment?.assessment_score == 50)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_74, "Not Competent"))
                                              : (data?.training_assessment?.assessment_score == 0)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_75, "Absent"))
                                                : (data?.training_assessment?.assessment_score == -1)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_76, "Dropout (Attendance " + _toDisplayString(data?.attendance_percentage) + " is below " + _toDisplayString(data?.batch_info?.dropout_below_perc) + ")", 1))
                                                  : _createCommentVNode("", true)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (data?.attendance_percentage < data?.batch_info?.dropout_below_perc)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_77, "Dropout (Attendance " + _toDisplayString(data?.attendance_percentage) + " is below " + _toDisplayString(data?.batch_info?.dropout_below_perc) + ")", 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_78, "Not Assessed Yet"))
                                        ], 64))
                                  ], 64))
                                : (this.trainee.term_no != '' && this.isTermAssessment == 1)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (data?.training_term_assessment?.assessment_score)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (data?.training_term_assessment?.assessment_score == 100)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_79, "Competent"))
                                              : (data?.training_term_assessment?.assessment_score == 50)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_80, "Not Competent"))
                                                : (data?.training_term_assessment?.assessment_score == 0)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_81, "Absent"))
                                                  : (data?.training_term_assessment?.assessment_score == -1)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_82, "Dropout (Attendance " + _toDisplayString(data?.attendance_percentage) + " is below " + _toDisplayString(data?.batch_info?.dropout_below_perc) + ")", 1))
                                                    : _createCommentVNode("", true)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (data?.attendance_percentage < data?.batch_info?.dropout_below_perc)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_83, "Dropout (Attendance " + _toDisplayString(data?.attendance_percentage) + " is below " + _toDisplayString(data?.dropout_below_perc) + ")", 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_84, "Not Assessed Yet"))
                                          ], 64))
                                    ], 64))
                                  : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.load]
  ])
}